
import { func_validation } from "functions";

export function usePermissionSelection(props) {
    const {
        selectedData, initUpdateData,
        tableData, updatedData,
        setIsRenderingRequired
    } = props;

    function handleMainCheckboxSelection(isChecked, userGroupId, userGroupPermissionName) {
        let selectedData_new = func_validation.deepCloneArray(selectedData.current);

        if (func_validation.isNumberValid(userGroupId) &&
            func_validation.isStringTrimNotEmpty(userGroupPermissionName) &&
            func_validation.isArrayNotEmpty(selectedData_new)) {
            
            // Find the user group permission
            for (let i = 0; i < tableData.length; i++) {
                let userGroupPermissionName_fromList = func_validation.getObjectPropertyValue(tableData[i], "UserGroupPermission");

                if (userGroupPermissionName_fromList === userGroupPermissionName) {
                    let permissionList = func_validation.getObjectPropertyValue(tableData[i], "PermissionList");

                    // Get group permission array for the user group id
                    for (let j = 0; j < selectedData_new.length; j++) {
                        let userGroupId_fromList = func_validation.getObjectPropertyValue(selectedData_new[j], "ID");

                        if (userGroupId_fromList === userGroupId) {
                            let groupPermissions = func_validation.getObjectPropertyValue(selectedData_new[j], "GroupPermissions");
                            
                            // Add all the permissions under this user group permission
                            let updatedData_new = func_validation.deepCloneObject(updatedData.current);
                            permissionList.map((permissionObj) => {
                                let fullPermissionString = func_validation.getObjectPropertyValue(permissionObj, "Original");

                                // Add to 'selected data' list
                                let permissionId = 0;
                                if (initUpdateData.current[userGroupId] &&
                                    initUpdateData.current[userGroupId][fullPermissionString])
                                    permissionId = initUpdateData.current[userGroupId][fullPermissionString];

                                if (func_validation.isArray(groupPermissions)) {
                                    if (isChecked) {
                                        // Check if the checkbox was perviously selected
                                        let isCheckboxSelected = false;
                                        for (let index = 0; index < groupPermissions.length; index++) {
                                            let permissionObj = groupPermissions[index];
                                            let permission = func_validation.getObjectPropertyValue(permissionObj, "PermissionName");
    
                                            if (permission === fullPermissionString) {
                                                isCheckboxSelected = true;
                                                break;
                                            }
                                        }

                                        // Add to list
                                        if (!isCheckboxSelected) {
                                            groupPermissions.push({
                                                "ID": permissionId,
                                                "PermissionName": fullPermissionString,
                                                "UserGroupId": userGroupId,
                                            });
                                        }
                                    }
                                    else if (groupPermissions.length > 0) {
                                        for (let index = 0; index < groupPermissions.length; index++) {
                                            let permissionObj = groupPermissions[index];
                                            let permission = func_validation.getObjectPropertyValue(permissionObj, "PermissionName");

                                            if (permission === fullPermissionString) {
                                                groupPermissions.splice(index, 1);
                                                break;
                                            }
                                        }
                                    }
                                }

                                // Compare data with initial data
                                if (initUpdateData.current[userGroupId] &&
                                    initUpdateData.current[userGroupId][fullPermissionString] &&
                                    updatedData_new?.deleted) {

                                    // Deleted
                                    if ((!isChecked) && func_validation.isNumberValid(permissionId)) {
                                        if (!updatedData_new.deleted[userGroupId]) {
                                            updatedData_new.deleted[userGroupId] = {};
                                        }
                                        updatedData_new.deleted[userGroupId][fullPermissionString] = permissionId;
                                    }
                                    else if (updatedData_new.deleted[userGroupId] &&
                                        updatedData_new.deleted[userGroupId][fullPermissionString]) {

                                        delete updatedData_new.deleted[userGroupId][fullPermissionString];

                                        if (func_validation.isObjectEmpty(updatedData_new.deleted[userGroupId]))
                                            delete updatedData_new.deleted[userGroupId];
                                    }

                                    // Remove from 'added' object
                                    if (updatedData_new.added[userGroupId] &&
                                        updatedData_new.added[userGroupId][fullPermissionString]) {

                                        delete updatedData_new.added[userGroupId][fullPermissionString];

                                        if (func_validation.isObjectEmpty(updatedData_new.added[userGroupId]))
                                            delete updatedData_new.added[userGroupId];
                                    }

                                }
                                else if (!(initUpdateData.current[userGroupId] &&
                                    initUpdateData.current[userGroupId][fullPermissionString]) &&
                                    updatedData_new?.added) {

                                    // Added
                                    if (isChecked) {
                                        if (!updatedData_new.added[userGroupId]) {
                                            updatedData_new.added[userGroupId] = {};
                                        }
                                        updatedData_new.added[userGroupId][fullPermissionString] = true;
                                    }
                                    else if (updatedData_new.added[userGroupId] &&
                                        updatedData_new.added[userGroupId][fullPermissionString]) {

                                        delete updatedData_new.added[userGroupId][fullPermissionString];

                                        if (func_validation.isObjectEmpty(updatedData_new.added[userGroupId]))
                                            delete updatedData_new.added[userGroupId];
                                    }

                                    // Remove from 'deleted' object
                                    if (updatedData_new.deleted[userGroupId] &&
                                        updatedData_new.deleted[userGroupId][fullPermissionString]) {

                                        delete updatedData_new.deleted[userGroupId][fullPermissionString];

                                        if (func_validation.isObjectEmpty(updatedData_new.deleted[userGroupId]))
                                            delete updatedData_new.deleted[userGroupId];
                                    }
                                }
                            });

                            updatedData.current = updatedData_new;
                            selectedData.current = selectedData_new;
                            setIsRenderingRequired(isRenderingRequired => !isRenderingRequired);

                            break;
                        }
                    }

                    break;
                }
            }
        }
    }
    function handleSubCheckboxSelection(isChecked, userGroupId, permission) {
        let selectedData_new = func_validation.deepCloneArray(selectedData.current);

        if (func_validation.isNumberValid(userGroupId) &&
            func_validation.isStringTrimNotEmpty(permission) &&
            func_validation.isArrayNotEmpty(selectedData_new)) {

            // Get group permission array for the user group id
            for (let i = 0; i < selectedData_new.length; i++) {
                let userGroupId_fromList = func_validation.getObjectPropertyValue(selectedData_new[i], "ID");

                // Add permissions under this user group permission
                if (userGroupId_fromList === userGroupId) {
                    let groupPermissions = func_validation.getObjectPropertyValue(selectedData_new[i], "GroupPermissions");
                    
                    // Add to 'selected data' list
                    let permissionId = 0;
                    if (isChecked) {
                        if (initUpdateData.current[userGroupId] &&
                            initUpdateData.current[userGroupId][permission])
                            permissionId = initUpdateData.current[userGroupId][permission];

                        groupPermissions.push({
                            "ID": permissionId,
                            "PermissionName": permission,
                            "UserGroupId": userGroupId,
                        });
                    }
                    else {
                        groupPermissions.map((permissionObj, idx) => {
                            let id = func_validation.getObjectPropertyValue(permissionObj, "ID");
                            let permission_fromList = func_validation.getObjectPropertyValue(permissionObj, "PermissionName");

                            if (permission_fromList === permission) {
                                permissionId = id;
                                groupPermissions.splice(idx, 1);
                            }
                        })
                    }

                    // Compare data with initial data
                    let updatedData_new = func_validation.deepCloneObject(updatedData.current);
                    if (initUpdateData.current[userGroupId] &&
                        initUpdateData.current[userGroupId][permission] &&
                        updatedData_new?.deleted) {

                        // Deleted
                        if ((!isChecked) && func_validation.isNumberValid(permissionId)) {
                            if (!updatedData_new.deleted[userGroupId]) {
                                updatedData_new.deleted[userGroupId] = {};
                            }
                            updatedData_new.deleted[userGroupId][permission] = permissionId;
                        }
                        else if (updatedData_new.deleted[userGroupId] && 
                            updatedData_new.deleted[userGroupId][permission]) {

                            delete updatedData_new.deleted[userGroupId][permission];

                            if (func_validation.isObjectEmpty(updatedData_new.deleted[userGroupId]))
                                delete updatedData_new.deleted[userGroupId];
                        }

                        // Remove from 'added' object
                        if (updatedData_new.added[userGroupId] &&
                            updatedData_new.added[userGroupId][permission]) {

                            delete updatedData_new.added[userGroupId][permission];

                            if (func_validation.isObjectEmpty(updatedData_new.added[userGroupId]))
                                delete updatedData_new.added[userGroupId];
                        }
                    }
                    else if (!(initUpdateData.current[userGroupId] &&
                        initUpdateData.current[userGroupId][permission]) &&
                        updatedData_new?.added) {

                        // Added
                        if (isChecked) {
                            if (!updatedData_new.added[userGroupId]) {
                                updatedData_new.added[userGroupId] = {};
                            }
                            updatedData_new.added[userGroupId][permission] = true;
                        }
                        else if (updatedData_new.added[userGroupId] &&
                            updatedData_new.added[userGroupId][permission]) {

                            delete updatedData_new.added[userGroupId][permission];

                            if (func_validation.isObjectEmpty(updatedData_new.added[userGroupId]))
                                delete updatedData_new.added[userGroupId];
                        }

                        // Remove from 'deleted' object
                        if (updatedData_new.deleted[userGroupId] &&
                            updatedData_new.deleted[userGroupId][permission]) {

                            delete updatedData_new.deleted[userGroupId][permission];

                            if (func_validation.isObjectEmpty(updatedData_new.deleted[userGroupId]))
                                delete updatedData_new.deleted[userGroupId];
                        }
                    }

                    updatedData.current = updatedData_new;
                    selectedData.current = selectedData_new;
                    setIsRenderingRequired(isRenderingRequired => !isRenderingRequired);

                    break;
                }
            }
        }
    }

    return {
        handleMainCheckboxSelection,
        handleSubCheckboxSelection
    }
}